// @flow

import React from 'react';
import { fuzzysearch } from '../../../../utils/fuzzysearch';
import type { BranchLevel, SearchedBranchLevel } from '../../../../types/apolloType';

type Props = {
  selectSources: BranchLevel[],
  handleChange: Function,
  placeholder: string,
  closeMenu: Function,
  side?: 'left' | 'right' | 'bottom' | 'top',
  sort: ?boolean,
  selectedList: SearchedBranchLevel[],
};

type State = {
  searchWord: string,
};

class SearchSelectBL extends React.Component<Props, State> {
  static defaultProps = {
    side: 'bottom',
    sort: true,
  };
  state = {
    searchWord: '',
  };

  handleChange = (event: EventHandler) => {
    this.setState({
      searchWord: event.target.value,
    });
  };

  searchResult = (value: BranchLevel) => {
    if (this.state.searchWord !== '' && value) {
      return fuzzysearch(this.state.searchWord, value.label) || (value.listBl.filter(s => fuzzysearch(this.state.searchWord, s.label)).length > 0);
    }
    return false;
  };

  isSelected = (value: BranchLevel) => this.props.selectedList.filter(item => value.id === item.id).length !== 0;

  render() {
    return (
      <div
        role="presentation"
        className={`select-array-container ${this.props.side || 'bottom'}`}
      >
        <div className="search-input">
          <input
            type="search"
            onChange={this.handleChange}
            placeholder={this.props.placeholder}
          />
        </div>
        <div
          role="presentation"
          className="select-array"
        >
          {
            this.props.selectSources && this.props.selectSources.filter((value) => {
              if (this.state.searchWord !== '' && value) {
                return this.searchResult(value);
              }
              return true;
            }).sort((a, b) => (this.props.sort ? a.label.localeCompare(b.label) : 0))
              .map(value => (
                <div key={value.id}>
                  <button
                    className={`search-filter${this.isSelected(value) ? ' active' : ''}`}
                    key={value.id}
                    onClick={() => this.props.handleChange(value.id, value.idParent)}
                  >
                    <p className="bl1">
                      {
                        value.label
                      }
                    </p>
                  </button>
                  {value.listBl.map(bl => (
                    <button
                      className={`search-filter${this.isSelected(bl) ? ' active' : ''}`}
                      key={bl.id}
                      onClick={() => this.props.handleChange(bl.id, bl.idParent)}
                    >
                      <p className="bl2">
                        {bl.label}
                      </p>
                    </button>
                  ))}
                </div>
              ))
          }
        </div>
        <button
          onClick={this.props.closeMenu}
          className="apollo-button"
        >
          Done
        </button>
      </div>
    );
  }
}

export default SearchSelectBL;
